import { render, staticRenderFns } from "./RevenuePerMonth.vue?vue&type=template&id=b2b95d1c&scoped=true&"
import script from "./RevenuePerMonth.vue?vue&type=script&lang=js&"
export * from "./RevenuePerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b95d1c",
  null
  
)

export default component.exports